import React, {createContext, useContext, useState} from 'react';

const NotificationContext = createContext();

export function NotificationProvider({children}) {
  const [selectedNotification, setSelectedNotification] = useState(null);

  return (
    <NotificationContext.Provider value={{selectedNotification, setSelectedNotification}}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
}
